import React from "react"
import {Link} from "@mui/material"

import type {UnidentifiedMessage} from "../types"

const NO_SINGLE_REGION_OWNER = "NoSingleRegionOwner"

const twins: Record<string, {label: string; origin: string}> = {
	prod: {label: "Rocket US", origin: "https://rocket.us.indebted.co"},
	produs: {label: "Rocket", origin: "https://rocket.indebted.co"},
}

function TwinRegionLink({message}: {message: UnidentifiedMessage}) {
	const twin = twins[import.meta.env.VITE_ENV]
	if (message.DeferralReason !== NO_SINGLE_REGION_OWNER || !twin) return null

	const path = [
		"/inbox",
		encodeURIComponent(message.Channel),
		encodeURIComponent(message.ConversationID),
		encodeURIComponent(message.ProviderMessageID),
	].join("/")

	return (
		<Link href={twin.origin + path} target="_blank" rel="noopener noreferrer" variant="caption" underline="hover">
			Check {twin.label} →
		</Link>
	)
}

export {TwinRegionLink}
